import { createStoreSelector } from "../selectors";
export const selectProgram = (state) => createStoreSelector(state, 'program')(state);
//# sourceMappingURL=program.selectors.js.map